import { IconCalculator, IconReceipt, IconTrendingUp } from '../../../common/icons';

import '../styles/invitation.css';

// TSS vite/03 — camino del NO-inversionista: invitación a invertir en genética.
// Aspiracional pero honesto: una curva ILUSTRATIVA de valorización + la
// propuesta de valor (valorización, liquidación mensual, retorno por crías) +
// cómo funciona + un llamado a la acción. Sin dato real (el cliente aún no es
// socio); la curva se rotula como ilustrativa.

// Contacto placeholder — reemplazar por el canal real de la empresa.
const CTA_MAILTO = 'mailto:inversiones@manantiales.co?subject=Quiero%20invertir%20en%20gen%C3%A9tica%20COWRE';

const VALUE = [
    { icon: <IconTrendingUp />, title: 'Valorización', text: 'El valor de tu donadora sube con avalúos fechados. Ves tu capital crecer como en una acción.' },
    { icon: <IconCalculator />, title: 'Liquidación mensual', text: 'Recibes tu reparto del manejo cada mes, según tu porcentaje de participación.' },
    { icon: <IconReceipt />, title: 'Retorno por crías', text: 'Cada cría vendida de tu donadora suma a tu retorno — genética que rinde.' },
];

const STEPS = [
    'Eliges un porcentaje de una donadora élite en oferta.',
    'Quedas como co-propietario, con todo trazado y verificable.',
    'Cobras valorización, liquidaciones y retorno por crías.',
];

// Curva ilustrativa (área) — puramente decorativa, rotulada como tal.
function TeaserCurve() {
    return (
        <svg className="invite__curve" viewBox="0 0 520 200" preserveAspectRatio="none" aria-hidden="true">
            <defs>
                <linearGradient id="invite-fill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor="var(--color-primary)" stopOpacity="0.28" />
                    <stop offset="1" stopColor="var(--color-primary)" stopOpacity="0" />
                </linearGradient>
            </defs>
            <path d="M0 168 C 90 160, 130 150, 190 120 S 300 70, 360 66 S 470 34, 520 18 L 520 200 L 0 200 Z" fill="url(#invite-fill)" />
            <path d="M0 168 C 90 160, 130 150, 190 120 S 300 70, 360 66 S 470 34, 520 18" fill="none" stroke="var(--color-primary)" strokeWidth="3" strokeLinecap="round" />
            <circle cx="520" cy="18" r="5" fill="var(--color-primary)" />
        </svg>
    );
}

export default function InvestInvitation() {
    return (
        <section className="invite">
            <div className="invite__hero">
                <div className="invite__hero-copy">
                    <span className="invite__eyebrow">Inversión en genética</span>
                    <h1 className="invite__title">Sé socio de una donadora élite y haz crecer tu capital.</h1>
                    <p className="invite__lead">
                        Todavía no tienes participación en ninguna vaca. Con COWRE puedes invertir en genética Cebú
                        de alto valor y ver crecer tu inversión — demostrable, tuya y con retorno real.
                    </p>
                    <div className="invite__cta-row">
                        <a className="invite__cta invite__cta--primary" href={CTA_MAILTO}>Quiero invertir</a>
                        <a className="invite__cta invite__cta--ghost" href="#como-funciona">Cómo funciona</a>
                    </div>
                </div>
                <div className="invite__hero-viz">
                    <div className="invite__viz-head">
                        <span className="invite__viz-label">Así crece tu inversión</span>
                        <span className="invite__viz-badge">ilustrativo</span>
                    </div>
                    <TeaserCurve />
                    <div className="invite__viz-foot">
                        <span>Valor de tu participación</span>
                        <span className="invite__viz-up">↑ crece con cada avalúo</span>
                    </div>
                </div>
            </div>

            <div className="invite__value">
                {VALUE.map((v) => (
                    <article key={v.title} className="invite__card">
                        <span className="invite__card-icon">{v.icon}</span>
                        <h3 className="invite__card-title">{v.title}</h3>
                        <p className="invite__card-text">{v.text}</p>
                    </article>
                ))}
            </div>

            <div className="invite__how" id="como-funciona">
                <h2 className="invite__how-title">Cómo funciona</h2>
                <ol className="invite__steps">
                    {STEPS.map((s, i) => (
                        <li key={i} className="invite__step">
                            <span className="invite__step-num">{i + 1}</span>
                            <span className="invite__step-text">{s}</span>
                        </li>
                    ))}
                </ol>
                <a className="invite__cta invite__cta--primary invite__how-cta" href={CTA_MAILTO}>Hablar con el equipo</a>
            </div>
        </section>
    );
}
